import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as Location } from '../static/img/location.svg';
import { ReactComponent as PersonPlus } from '../static/img/person-plus.svg';

const AppointmentCard = ({
  timeLabel,
  formattedDate,
  appointmentTypeName,
  statusBadge,
  locations,
  practitioners,
  onViewDetails,
  footer,
  showDivider,
}) => (
  <div className="appointment-card">
    <div className="class-content__wrapper">
      <div className="class-time__wrapper">
        <div className="class-time bold">{timeLabel}</div>
        <div className="class-date">{formattedDate}</div>
      </div>
      <div className="class-details__wrapper">
        <div className="appointment-tile-header">
          <h2 className="h2 bold">{appointmentTypeName}</h2>
          {statusBadge}
        </div>
        {locations?.[0] && (
          <div className="class__detail">
            <Location />
            <span>{locations[0]['location-display-name']}</span>
          </div>
        )}
        <div>
          {practitioners?.map((practitioner, index) => (
            <div className="detail" key={practitioner['practitioner-id']}>
              <span className="location-icon__wrapper">{index === 0 && <PersonPlus />}</span>
              <span className="location-name">{practitioner['practitioner-name']}</span>
            </div>
          ))}
        </div>
        <br></br>
        <a className="link view-details" href="#" onClick={onViewDetails}>
          View details
        </a>
      </div>
    </div>

    {footer}

    {showDivider ? (
      <div className="appointment-card__divider" />
    ) : (
      <div className="appointment-card__spacer" />
    )}
  </div>
);

AppointmentCard.propTypes = {
  timeLabel: PropTypes.string.isRequired,
  formattedDate: PropTypes.string.isRequired,
  appointmentTypeName: PropTypes.string,
  statusBadge: PropTypes.node,
  locations: PropTypes.array,
  practitioners: PropTypes.array,
  onViewDetails: PropTypes.func.isRequired,
  footer: PropTypes.node,
  showDivider: PropTypes.bool,
};

AppointmentCard.defaultProps = {
  showDivider: true,
};

export default AppointmentCard;
